import { useShallow } from 'zustand/react/shallow';
import { usePrenuvoStore } from '@/stores/usePrenuvoStore';
import { useEffect } from 'react';
import { handleDefaultSku } from '@/utils/sku370';

export const useDefaultSku = () => {
  const { location, setSkuId } = usePrenuvoStore(
    useShallow((state) => ({
      location: state.scan.location,
      skuId: state.scan.skuId,
      setSkuId: state.scan.methods.setSku,
    })),
  );

  useEffect(() => {
    const defaultSku = handleDefaultSku(location?.code!, location?.skus);
    setSkuId(defaultSku!);
  }, [location?.code, setSkuId]);
};
